import { render, staticRenderFns } from "./transport.vue?vue&type=template&id=12710a4c&"
import script from "./transport.vue?vue&type=script&lang=js&"
export * from "./transport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports